// extracted by mini-css-extract-plugin
export var flex = "flex-module--flex--373jK";
export var autoLayout = "flex-module--autoLayout--1wvex";
export var collapseOnMd = "flex-module--collapseOnMd--2qu7Z";